export default __webpack_public_path__ + "ba3227d565b926d59b063de9eec03695.png";